import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { heroSlides } from "@/mocks/movie";

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);
  const count = heroSlides.length;

  useEffect(() => {
    const timer = setInterval(() => setIndex((i) => (i + 1) % count), 6500);
    return () => clearInterval(timer);
  }, [count]);

  const go = (i: number) => setIndex((i + count) % count);

  return (
    <section className="relative h-[560px] w-full overflow-hidden md:h-[680px]" aria-label="焦点内容轮播">
      {heroSlides.map((slide, i) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            i === index ? "opacity-100" : "pointer-events-none opacity-0"
          }`}
          aria-hidden={i !== index}
        >
          <img
            src={slide.image}
            alt={slide.title}
            title={`${slide.title} - 激情丛林电影`}
            className={`h-full w-full object-cover object-top ${i === index ? "ken-burns" : ""}`}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-background-950/75 via-background-950/65 to-background-950"></div>

          <div className="absolute inset-0 flex items-center">
            <div className="mx-auto w-full px-4 text-center md:px-6">
              <span className="inline-flex items-center gap-2 rounded-full border border-accent-500/40 bg-background-950/50 px-4 py-1.5 font-label text-xs tracking-widest text-accent-400 backdrop-blur">
                <i className="ri-vip-diamond-line"></i>
                {slide.tag}
              </span>
              <h2 className="mx-auto mt-5 max-w-4xl font-heading text-2xl font-bold leading-tight text-foreground-50 md:text-5xl">
                {slide.title}
              </h2>
              <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-foreground-300 md:text-base">
                {slide.desc}
              </p>
              <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
                <Link
                  to={slide.link}
                  className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 font-label text-sm font-semibold text-background-950 transition-colors hover:bg-accent-400"
                >
                  {slide.cta}
                  <i className="ri-arrow-right-line"></i>
                </Link>
                <Link
                  to="/about"
                  className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-600 px-6 py-3 font-label text-sm text-foreground-100 transition-colors hover:border-accent-400 hover:text-accent-400"
                >
                  <i className="ri-film-line"></i>
                  影片资料
                </Link>
              </div>
            </div>
          </div>
        </div>
      ))}

      <button
        type="button"
        onClick={() => go(index - 1)}
        className="absolute left-3 top-1/2 z-10 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-background-600 bg-background-950/50 text-foreground-200 backdrop-blur transition-colors hover:border-accent-400 hover:text-accent-400 md:left-6 md:h-12 md:w-12"
        aria-label="上一张"
      >
        <i className="ri-arrow-left-s-line text-xl"></i>
      </button>
      <button
        type="button"
        onClick={() => go(index + 1)}
        className="absolute right-3 top-1/2 z-10 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-background-600 bg-background-950/50 text-foreground-200 backdrop-blur transition-colors hover:border-accent-400 hover:text-accent-400 md:right-6 md:h-12 md:w-12"
        aria-label="下一张"
      >
        <i className="ri-arrow-right-s-line text-xl"></i>
      </button>

      <div className="absolute bottom-8 left-1/2 z-10 flex -translate-x-1/2 items-center gap-2.5">
        {heroSlides.map((slide, i) => (
          <button
            key={slide.id}
            type="button"
            onClick={() => go(i)}
            className={`h-1.5 rounded-full transition-all duration-300 ${
              i === index ? "w-8 bg-accent-500" : "w-3 bg-background-500 hover:bg-background-300"
            }`}
            aria-label={`切换到第 ${i + 1} 张`}
          />
        ))}
      </div>
    </section>
  );
}